<div [formGroup]="group">

    <ng-container *ngIf="showFieldLabelName">
        <h2 *ngIf="config.direction === 'Oneway'" class="form-title">{{ Yii.t('wui-shared-js', 'Aller Simple') }}</h2>
        <h2 *ngIf="config.direction === 'Return'" class="form-title">{{ Yii.t('wui-shared-js', 'Aller-Retour') }}</h2>
        <h2 *ngIf="config.direction === 'Multiple'"
            class="form-title">{{ Yii.t('wui-shared-js', 'Multi-destination') }}</h2>
    </ng-container>

    <div [class.col-to-row-s-tb]="config.direction !== 'Multiple'"
         [class.ctn-right-left]="config.direction !== 'Multiple'"
         [class.flex-1]="config.direction !== 'Multiple'"
         [class.multiple-container]="config.direction === 'Multiple'">
        <ng-container *ngIf="config.direction === 'Oneway'">
            <ng-container *ngFor="let segment of group.controls; let i = index" [formGroupName]="i" class="OneWay">

                <div [formGroup]="segment" class="one-way col-to-row-s-tb top flex-1 ctn-right-left">
                    <div class="field-sep flex-1">
                        <airport-select [firstLocationCode]="segment.get(eField.from).value"
                            [tabindex]="0"
                            [readonlyIfSet]="readonlyWhenSetRules[config.direction]?.from?.airport"
                            direction="from"
                            [firstIsAirportOnly]="segment.get('fromAirportOnly').value"
                            [customizedIconDefinition]="customizedIcons?.from ? customizedIcons : null"
                            (onChooseLocation)="patchSegment(i, eField.from, $event)"></airport-select>
                    </div>

                    <btn *ngIf="allowInvertFromTo"
                        class="invert-button"
                        icon="exchange-alt"
                        [title]="wording.invertFromTo"
                        [isAccessedWithTab]="false"
                        [type]="btnType.roundO"
                        (onClick)="invertFromTo(i)"></btn>

                    <div class="field-sep flex-1">
                        <airport-select [firstLocationCode]="segment.get(eField.to).value"
                            [tabindex]="1"
                            [readonlyIfSet]="readonlyWhenSetRules[config.direction]?.to?.airport"
                            [firstIsAirportOnly]="segment.get('fromAirportOnly').value"
                            direction="to"
                            [customizedIconDefinition]="customizedIcons?.to ? customizedIcons : null"
                            (onChooseLocation)="patchSegment(i, eField.to, $event)"></airport-select>
                    </div>
                    <date-field class="sep-bottom flex-1"
                                [iconCalendar]="customizedIcons?.date ? customizedIcons.date : null"
                                [onlyOneMonth]="onlyOneMonth"
                                [fieldConfig]="{formGroup: segment,
                                     formControlName: 'begin',
                                     minDate:today,
                                     placeholder: wording.date,
                                     validators: dateValidator}"></date-field>
                </div>
            </ng-container>
        </ng-container>
        <div *ngIf="config.direction === 'Return'" class="return-way col-to-row-s-tb top flex-1 ctn-right-left">
            <ng-container *ngFor="let segment of group.controls; let i = index" [formGroupName]="i">
                <ng-container [formGroup]="segment">
                    <ng-container *ngIf="i === 0">
                        <div class="field-sep flex-1">
                            <airport-select class="e2e-air-from"
                                [firstLocationCode]="segment.get(eField.from).value"
                                [readonlyIfSet]="readonlyWhenSetRules[config.direction]?.from?.airport"
                                [firstIsAirportOnly]="segment.get('fromAirportOnly').value"
                                direction="from"
                                [customizedIconDefinition]="customizedIcons?.from ? customizedIcons : null"
                                (onChooseLocation)="patchSegment(i, eField.from, $event)"></airport-select>
                        </div>

                        <btn *ngIf="allowInvertFromTo"
                            [isAccessedWithTab]="false"
                            [type]="btnType.roundO"
                            [title]="wording.invertFromTo"
                            class="invert-button"
                            icon="exchange-alt"
                            (onClick)="invertFromTo(i)"></btn>

                        <div class="field-sep flex-1">
                            <airport-select class="e2e-air-to"
                                [firstLocationCode]="segment.get(eField.to).value"
                                [readonlyIfSet]="readonlyWhenSetRules[config.direction]?.to?.airport"
                                [firstIsAirportOnly]="segment.get('toAirportOnly').value"
                                direction="to"
                                [customizedIconDefinition]="customizedIcons?.to ? customizedIcons : null"
                                (onChooseLocation)="patchSegment(i, eField.to, $event)"></airport-select>
                        </div>
                        <date-field class="field-sep flex-1 e2e-begin-field"
                            [iconCalendar]="customizedIcons?.date ? customizedIcons.date : null"
                            [onlyOneMonth]="onlyOneMonth"
                            [fieldConfig]="{formGroup: segment,
                                formControlName: 'begin',
                                minDate:today,
                                defaultDate:getLastDate(1),
                                placeholder: wording.dateBegin,
                                validators: dateValidator}"
                            (onBlur)="setReturnDate()"
                            (onSelect)="setReturnDate();openAndFocusReturnDate()"></date-field>
                    </ng-container>
                    <date-field #returnDate *ngIf="i === 1"
                        class="flex-1 sep-bottom e2e-return-field"
                        [onlyOneMonth]="onlyOneMonth"
                        [iconCalendar]="customizedIcons?.date ? customizedIcons.date : null"
                        [fieldConfig]="{formGroup: segment,
                                formControlName: 'begin',
                                minDate:getLastDate(1),
                                defaultDate:getLastDate(1),
                                placeholder: wording.dateEnd,
                                validators: dateValidator}"
                        (onBlur)="setReturnDate()"></date-field>
                </ng-container>
            </ng-container>
        </div>
        <ng-container *ngIf="config.direction === 'Multiple'">
            <div *ngFor="let segment of group.controls; let i = index" [formGroupName]="i" class="Multiple">
                <div [formGroup]="segment">
                    <div class="col-to-row-s-tb top multiple-way">
                        <div class="field-sep" [class.flex-1]="allowInvertFromTo">
                            <airport-select [firstLocationCode]="segment.get(eField.from).value"
                                [firstIsAirportOnly]="segment.get('fromAirportOnly').value"
                                direction="from"
                                [customizedIconDefinition]="customizedIcons?.from ? customizedIcons : null"
                                (onChooseLocation)="patchSegment(i, eField.from, $event)"></airport-select>
                        </div>

                        <btn *ngIf="allowInvertFromTo"
                            [isAccessedWithTab]="false"
                            [type]="btnType.roundO"
                            [title]="wording.invertFromTo"
                            class="invert-button"
                            icon="exchange-alt"
                            (onClick)="invertFromTo(i)"></btn>

                        <div class="field-sep" [class.flex-1]="allowInvertFromTo">
                            <airport-select [firstLocationCode]="segment.get(eField.to).value"
                                [readonlyIfSet]="readonlyWhenSetRules[config.direction]?.to?.airport"
                                [firstIsAirportOnly]="segment.get('fromAirportOnly').value"
                                direction="to"
                                [customizedIconDefinition]="customizedIcons?.to ? customizedIcons : null"
                                (onChooseLocation)="patchSegment(i, eField.to, $event)"></airport-select>
                        </div>
                        <date-field class="field-sep add-margin-right"
                                    [onlyOneMonth]="onlyOneMonth"
                                    [class.flex-1]="allowInvertFromTo"
                                    [iconCalendar]="customizedIcons?.date ? customizedIcons.date : null"
                                    [fieldConfig]="{formGroup: segment,
                                     formControlName: 'begin',
                                     defaultDate: getNewDate( i ),
                                     minDate:getLastDate( i ),
                                     placeholder: wording.date,
                                      validators: dateValidator}"></date-field>
                        <div class="seg-btn-ctn field-sep">
                            <btnForm styleType="actionLink"
                                     *ngIf="group.controls.length > 1" (click)="removeField(i)">
                                <fa-icon [icon]="iconMinus"></fa-icon>
                            </btnForm>
                            <btnForm styleType="actionLink"
                                     (click)="addFields()"
                                     *ngIf="config.add && i === (group.controls.length-1)">
                                <fa-icon [icon]="iconPlus"></fa-icon>
                            </btnForm>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-content select=".end-poisitionned-area"></ng-content>
    </div>
</div>
